package link.erpango.quip.core.factory

import androidx.compose.runtime.Composable
import androidx.lifecycle.ViewModelStoreOwner
import androidx.lifecycle.viewmodel.compose.viewModel
import link.erpango.quip.domain.usecases.IAuthUseCase
import link.erpango.quip.features.auth.AuthViewModel

class AuthFactory(
    val authInteractor: IAuthUseCase,
    private val viewModelStoreOwner : ViewModelStoreOwner
): IFactory
{
    @Composable
    fun createAuthViewModel(): AuthViewModel {
        return viewModel(viewModelStoreOwner) {
            AuthViewModel(authInteractor)
        }
    }

    fun createAuthViewModelInstance(): AuthViewModel {
        viewModelStoreOwner.viewModelStore.put(AuthViewModel::class.simpleName ?: "", AuthViewModel(authInteractor))
        return AuthViewModel(authInteractor)
    }
}